import ListIcon from '@mui/icons-material/List';

import PreTripItems from "./PreTripItemsPage";

const exports = {
    Page: PreTripItems,
    Icon: ListIcon
};
export default exports;
